var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-container section-home" },
    [
      _c("section-code-reale", { attrs: { num: 0 } }),
      _c("section-intro", { attrs: { num: 2 } }),
      _c("section-video", { attrs: { num: 3 } }),
      _c("section-who", { attrs: { num: 4 } }),
      _c("section-luciano", { attrs: { num: 5 } }),
      _c("section-features", { attrs: { num: 6 } }),
      _c("section-footer-solution"),
      _c("section", { staticClass: "section border-bottom-section" }, [
        _c("div", { staticClass: "section-content" }, [
          _c("div", { staticClass: "columns is-centered is-vcentered" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                {
                  staticClass: "title is-spaced has-text-centered",
                  staticStyle: { "margin-bottom": ".8rem" },
                },
                [_vm._v(_vm._s(_vm.$t("about.title_have_company")))]
              ),
              _c("p", { staticClass: "subtitle has-text-centered" }, [
                _vm._v(_vm._s(_vm.$t("about.title_have_company2"))),
              ]),
              _c(
                "p",
                { staticClass: "subtitle has-text-centered" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "button is-primary",
                      attrs: { to: _vm.urlCompany },
                    },
                    [_vm._v(_vm._s(_vm.$t("button.find_how")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "modal-comp",
        {
          ref: "modalvideo",
          staticClass: "modal-video",
          attrs: { title: _vm.$t("menu.video") },
          on: { close: _vm.videoPopupClosed },
        },
        [
          _vm.videoPopup
            ? _c("div", { staticClass: "columns is-centered is-vcentered" }, [
                _c(
                  "video",
                  {
                    ref: "playervideo",
                    attrs: { width: "854", height: "480", controls: "" },
                  },
                  [
                    _vm.itLang
                      ? _c("source", {
                          attrs: {
                            src: "/videos/workout-ita.mp4",
                            type: "video/mp4",
                          },
                        })
                      : _vm.esLang
                      ? _c("source", {
                          attrs: {
                            src: "/videos/workout-eng.mp4",
                            type: "video/mp4",
                          },
                        })
                      : _c("source", {
                          attrs: {
                            src: "/videos/workout-eng.mp4",
                            type: "video/mp4",
                          },
                        }),
                    _vm._v(_vm._s(_vm.$t("home.no_video_support"))),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }